import { RefinementList } from './models';

function setOnlyOneQueryParam(key: string, value: string): string {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  let currentRefinementList: RefinementList = {};

  // Parse existing refinementList
  if (params.has('refinementList')) {
    try {
      currentRefinementList = JSON.parse(decodeURIComponent(params.get('refinementList') || '{}'));
    } catch (e) {
      console.error('Failed to parse refinementList:', e);
    }
  }

  // Update only the specified key
  currentRefinementList[key] = [value];

  // Set the updated refinementList back
  params.set('refinementList', JSON.stringify(currentRefinementList));

  // Update the URL without reloading the page
  url.search = params.toString();

  window.history.replaceState({}, '', url.toString());

  return url.toString();
}

export default setOnlyOneQueryParam;
